const checkFix = {
  existId (array, id, extendedStepsStart) {
    let specialJump
    // 强制用户结束答题 不能和结束答题共用
    if (extendedStepsStart > 0) {
      specialJump = ['nextTemplate', 'nextProduct']
    } else {
      specialJump = ['end', 'nextTemplate', 'nextProduct']
    }

    for (let data of array) {
      if (specialJump.includes(id) || data.id === id) {
        return true
      }
    }
    return false
  },
  // 强制用户结束答题 显示题和隐藏题之间不能有逻辑跳转
  existJumpToExtendedStep (array, jumpTargetId, extendedStepsStart) {
    for (let i = 0; i < array.length; i++) {
      if (i + 1 > extendedStepsStart) {
        if (array[i].id === jumpTargetId) {
          return true
        }
      }
    }
    return false
  },
  result (array, data, questionIndex, extendedStepsStart) {
    let results = {}
    if (data.hasOwnProperty('jumpTargetId') && data.jumpTargetId) {
      let isExist = this.existId(array, data.jumpTargetId, extendedStepsStart)
      if (!isExist) {
        results.isExistJumpTargetId = isExist
        results.jumpTargetId = data.jumpTargetId
      }
    }
    // 强制用户结束答题 显示题和隐藏题之间不能有逻辑跳转
    if (data.hasOwnProperty('jumpTargetId') && data.jumpTargetId && questionIndex < extendedStepsStart) {
      let isExist = this.existJumpToExtendedStep(array, data.jumpTargetId, extendedStepsStart)
      if (isExist) {
        results.isExistJumpToExtendedStep = isExist
      }
    }
    if (data.hasOwnProperty('referIds') && data.referIds.length) {
      for (let questionId of data.referIds) {
        let isExist = this.existId(array, questionId)
        if (!isExist) {
          results.referIds = isExist
          break
        }
      }
    }
    if (Object.keys(results).length) {
      return results
    }
    return false
  },
  test (questions, extendedStepsStart) {
    let results = []
    questions.forEach((question, questionIndex) => {
      let _result = this.result(questions, question, questionIndex, extendedStepsStart)

      if (_result) {
        results.push(Object.assign(_result, {question, questionIndex}))
      }

      // 验证选项
      if (question.hasOwnProperty('options')) {
        question.options.forEach((option, optionIndex) => {
          let _result = this.result(questions, option, questionIndex, extendedStepsStart)
          if (_result) {
            results.push(Object.assign(_result, {question, questionIndex, option, optionIndex}))
          }
        })
      }
    })
    return results
  },
  fix (results) {
    results.forEach((result) => {
      let data = result.question
      if (result.hasOwnProperty('option')) {
        data = result.option
      }
      if (result.isExistJumpTargetId === false || result.isExistJumpToExtendedStep === true) {
        data.jumpTargetId = ''
      }
      if (result.referIds === false) {
        data.referIds = []
      }
      console.log(result, data)
    })
  },
}

export default checkFix



// WEBPACK FOOTER //
// ./src/views/question-editor/utils/checkFix.js